import React, { useState, useEffect } from 'react';
import Sidennav from '../dashboard/sidenavbar';
import Topnavbar from '../dashboard/topnavbar';
import axios from "axios";
import { baseurladdress } from "../baseurl";
import Select from "react-select";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import Swal from "sweetalert2";
import moment from "moment";
function Attendancemanagement() {

    const accesstoken = localStorage.getItem("token");
    const accessuserid = localStorage.getItem("staffid");
    console.log("Access userid:", accessuserid);
    const [branch, setBranch] = useState([]);
    const [branchId, setBranchId] = useState("");
    const [selectedBranchName, setSelectedBranchName] = useState("");

    const [attendanceDate, setAttendanceDate] = useState(
        new Date().toISOString().split("T")[0]
    );

    const [staffList, setStaffList] = useState([]);

    const [shiftDetails, setShiftDetails] = useState({
        type_name: "",
        type_from: "",
        type_to: ""
    });
    const [showShiftPopup, setShowShiftPopup] =
        useState(false);

    const [availableShifts, setAvailableShifts] =
        useState([]);

    const [selectedShiftId, setSelectedShiftId] =
        useState("");
    useEffect(() => {

        const fetchBranches = async () => {

            try {

                const branchResponse = await axios.get(
                    `${baseurladdress}getallbranchs`,
                    {
                        headers: {
                            Authorization: `Bearer ${accesstoken}`
                        }
                    }
                );

                setBranch(
                    branchResponse.data.response || []
                );

                const userBranchResponse =
                    await axios.get(
                        `${baseurladdress}getuserbranch/${accessuserid}`,
                        {
                            headers: {
                                Authorization: `Bearer ${accesstoken}`
                            }
                        }
                    );

                if (
                    userBranchResponse.data.status === "success" &&
                    userBranchResponse.data.response.length > 0
                ) {

                    const userBranch =
                        userBranchResponse.data.response[0];

                    setBranchId(
                        userBranch.staff_placedat
                    );

                    setSelectedBranchName(
                        userBranch.branch_name
                    );

                    // STAFF SHIFT

                    const shiftResponse =
                        await axios.get(
                            `${baseurladdress}getStaffShift/${accessuserid}`,
                            {
                                headers: {
                                    Authorization:
                                        `Bearer ${accesstoken}`
                                }
                            }
                        );

                   
                    if (
                        shiftResponse.data.status === "success" &&
                        shiftResponse.data.response.length > 0
                    ) {

                        const shifts =
                            shiftResponse.data.response;

                        setAvailableShifts(shifts);

                        const shift = shifts[0];

                        setShiftDetails({
                            type_id: shift.type_id,
                            type_name: shift.type_name,
                            type_from: shift.type_from,
                            type_to: shift.type_to,
                            lead_time: shift.lead_time
                        });
                    }
                }

            } catch (error) {

                console.log(error);

            }
        };

        fetchBranches();

    }, []);
  
   
    // Punch in and out
   
    // const handlePunch = async (
    //     force_punch = 0,
    //     selectedShiftId = null
    // ) => {
    const handlePunch = async (
        force_punch = 0,
        selectedShiftId = null,
        continue_assigned = 0
    ) => {
        try {       
            const response = await axios.post(
                `${baseurladdress}punchattendance`,
                {
                    staffid: accessuserid,
                    branch_id: branchId,
                    date: attendanceDate,
                    shift_id: selectedShiftId,
                    force_punch,
                    continue_assigned
                   
                },
                {
                    headers: {
                        Authorization:
                            `Bearer ${accesstoken}`
                    }
                }
            );
            const res = response.data;

            console.log("Punch Response :", res);

            // =====================================
            // MULTIPLE SHIFTS
            // =====================================
            if (res.success === "multiple_shifts") {

                let shiftsHtml = `
        <div class="shift-container">
    `;

                res.shifts.forEach((shift) => {

                    shiftsHtml += `
            <label class="shift-card">
                <input
                    type="radio"
                    name="selectedShift"
                    value="${shift.shifttype_id}"
                />

                <div class="shift-content">
                    <div class="shift-name">
                        ${shift.type_name}
                    </div>

                    <div class="shift-time">
                        ${shift.shift_from} - ${shift.shift_to}
                    </div>
                </div>
            </label>
        `;
                });

                shiftsHtml += `</div>`;

                const result = await Swal.fire({

                    title: "Multiple Shifts Available",

                    html: shiftsHtml,

                    showCancelButton: true,

                    confirmButtonText: "Continue",

                    cancelButtonText: "Cancel",

                    width: "700px",

                    customClass: {
                        popup: "shift-popup"
                    },

                    didOpen: () => {

                        const style = document.createElement("style");

                        style.innerHTML = `

                .shift-container{
                    display:flex;
                    flex-wrap:wrap;
                    gap:12px;
                    margin-top:15px;
                    justify-content:center;
                }

                .shift-card{
                    width:200px;
                    border:1px solid #dbe3ef;
                    border-radius:12px;
                    padding:14px;
                    cursor:pointer;
                    transition:0.3s;
                    background:#fff;
                    display:flex;
                    align-items:flex-start;
                    gap:10px;
                }

                .shift-card:hover{
                    border-color:#6c63ff;
                    box-shadow:0 4px 12px rgba(108,99,255,0.15);
                }

                .shift-card input[type="radio"]{
                    margin-top:6px;
                    transform:scale(1.1);
                }

                .shift-content{
                    flex:1;
                }

                .shift-name{
                    font-size:16px;
                    font-weight:600;
                    color:#1f2937;
                    margin-bottom:6px;
                }

                .shift-time{
                    font-size:13px;
                    color:#6b7280;
                    white-space:nowrap; /* KEEP TIME IN ONE LINE */
                }

                .swal2-title{
                    font-size:28px !important;
                    font-weight:700 !important;
                }

            `;

                        document.head.appendChild(style);
                    },

                    preConfirm: () => {

                        const selected =
                            document.querySelector(
                                'input[name="selectedShift"]:checked'
                            );

                        if (!selected) {

                            Swal.showValidationMessage(
                                "Please select a shift"
                            );

                            return false;
                        }

                        return selected.value;
                    }
                });

                if (result.isConfirmed) {

                    await handlePunch(
                        force_punch,
                        result.value
                    );
                }

                return;
            }
           
            if (res.success === "assigned_shift_confirmation") {

                const assigned = res.assigned_shift;
                const fromTime = moment(assigned.shift_from, "HH:mm:ss").format("hh:mm A");
                const toTime = moment(assigned.shift_to, "HH:mm:ss").format("hh:mm A");
                const popup = await Swal.fire({

                    title: "",

                    html: `
    <div class="assigned-popup">

        <div class="assigned-icon">
            🕒
        </div>

        <div class="assigned-title">
            Assigned Shift
        </div>

        <div class="assigned-name">
            ${assigned.type_name}
        </div>

      <div class="assigned-time">
    ${fromTime} - ${toTime}
</div>

        <div class="assigned-message">
            This shift is already assigned to you.<br>
            Would you like to continue with this shift?
        </div>

    </div>
    `,

                    showCancelButton: true,

                    confirmButtonText: "Continue",

                    cancelButtonText: "Other Shift",

                    width: "500px",

                    customClass: {
                        popup: "assigned-shift-popup"
                    },

                    didOpen: () => {

                        const style = document.createElement("style");

                        style.innerHTML = `

.assigned-shift-popup{
    border-radius:20px;
    padding:25px;
}

.assigned-popup{
    text-align:center;
}

.assigned-icon{

    width:90px;
    height:90px;

    margin:auto;

    border-radius:50%;

    background:#EEF2FF;

    color:#4F46E5;

    font-size:42px;

    display:flex;

    justify-content:center;

    align-items:center;

    box-shadow:0 5px 15px rgba(79,70,229,.15);
}

.assigned-title{

    margin-top:20px;

    font-size:30px;

    font-weight:700;

    color:#222;
}

.assigned-name{

    margin-top:18px;

    display:inline-block;

    background:#EEF2FF;

    color:#4F46E5;

    padding:10px 28px;

    border-radius:30px;

    font-size:24px;

    font-weight:700;
}

.assigned-time{

    margin-top:18px;

    font-size:18px;

    color:#666;

    font-weight:600;
}

.assigned-message{

    margin-top:22px;

    font-size:16px;

    color:#555;

    line-height:1.6;
}

.swal2-confirm{

    background:#4F46E5 !important;

    border-radius:10px !important;

    padding:10px 30px !important;

    font-size:16px !important;
}

.swal2-cancel{

    background:#6B7280 !important;

    border-radius:10px !important;

    padding:10px 30px !important;

    font-size:16px !important;
}

`;

                        document.head.appendChild(style);
                    }

                });
        //         const popup = await Swal.fire({

        //             title: "Assigned Shift",

        //             html: `
        //     <h3>${assigned.type_name}</h3>

        //     <br>

        //     ${assigned.shift_from}
        //     -
        //     ${assigned.shift_to}

        //     <br><br>

        //     This shift is assigned to you.

        //     <br>

        //     Do you want to continue?
        // `,

        //             icon: "question",

        //             showCancelButton: true,

        //             confirmButtonText: "Continue",

        //             cancelButtonText: "Other Shift"

        //         });

                //------------------------------------------------
                // CONTINUE
                //------------------------------------------------
                if (popup.isConfirmed) {

                    await handlePunch(
                        0,
                        assigned.shifttype_id,
                        1
                    );

                    return;
                }
                // if (popup.isConfirmed) {

                //     await axios.post(

                //         `${baseurladdress}punchattendance`,

                //         {

                //             staffid: accessuserid,

                //             branch_id: branchId,

                //             date: attendanceDate,

                //             continue_assigned: true,

                //             shift_id: assigned.shifttype_id

                //         },

                //         {

                //             headers: {

                //                 Authorization:

                //                     `Bearer ${accesstoken}`

                //             }

                //         }

                //     ).then((response) => {

                //         toast.success(response.data.message);

                //         fetchAttendance(attendanceDate);

                //     });

                //     return;
                // }

                //------------------------------------------------
                // OTHER SHIFT
                //------------------------------------------------
                console.log("Overlapping Shifts:", res.overlapping_shifts);
                let html = `<div class="shift-container">`;
                function formatTime(time) {

                    const [hours, minutes] = time.split(":");

                    let hour = parseInt(hours, 10);

                    const ampm = hour >= 12 ? "PM" : "AM";

                    hour = hour % 12;

                    if (hour === 0) hour = 12;

                    return `${hour}:${minutes} ${ampm}`;
                }
                res.overlapping_shifts.forEach((shift) => {

                   
                    
                    const shiftColors = {
                        "Day Shift": "#FFDCE5",        // Soft Pink
                        "Morning Shift": "#DCFCE7",    // Soft Green
                        "Evening Shift": "#D6EFFF",    // Soft Blue
                        "Night Shift": "#E9D8FD",      // Soft Purple
                        "Afternoon Shift": "#FFF1C2",  // Soft Yellow
                        "Fixed Shift": "#D9F8F0"       // Soft Aqua
                    };

                    const bgColor = shiftColors[shift.type_name.trim()] || "#F5F5F5";
                   
                    html += `
    <label class="shift-card" style="background:${bgColor};">

        <input
            type="radio"
            name="selectedShift"
            value="${shift.shifttype_id}"
        >

        <div class="shift-content">

            <div class="shift-icon">
                🕒
            </div>

            <div class="shift-details">

                <div class="shift-name">
                    ${shift.type_name}
                </div>

             <div class="shift-time">
    ${formatTime(shift.shift_from)} - ${formatTime(shift.shift_to)}
</div>
            </div>

        </div>

    </label>
    `;

                });

                html += `</div>`;
                const shiftPopup = await Swal.fire({

                    title: "Multiple Shift Required",

                    html,

                    width: "720px",

                    showCancelButton: true,

                    confirmButtonText: "Continue",

                    cancelButtonText: "Cancel",

                    customClass: {
                        popup: "shift-popup"
                    },

                    didOpen: () => {

                        const style = document.createElement("style");

                        style.innerHTML = `

                            .shift-container{

                             display:grid;

                             grid-template-columns:repeat(auto-fit,minmax(250px,1fr));

                            gap:18px;

                            margin-top:20px;

                            }

.shift-card{

    display:block;

    cursor:pointer;

    border-radius:16px;

    padding:18px;

    transition:.3s;

    position:relative;

    border:2px solid transparent;

}

.shift-card:hover{

    transform:translateY(-4px);

    box-shadow:0 10px 25px rgba(0,0,0,.15);

}

.shift-card input{

    position:absolute;

    right:15px;

    top:15px;

    transform:scale(1.3);

}

.shift-content{

    display:flex;

    align-items:center;

    gap:15px;

}

.shift-icon{

    width:55px;

    height:55px;

    border-radius:50%;

    background:white;

    display:flex;

    justify-content:center;

    align-items:center;

    font-size:26px;

    box-shadow:0 4px 10px rgba(0,0,0,.1);

}

.shift-name{

    font-size:20px;

    font-weight:700;

    color:#222;

}

.shift-time{

    margin-top:6px;

    font-size:15px;

    color:#555;

}

.shift-card:has(input:checked){

    border:2px solid #4F46E5;

    box-shadow:0 0 15px rgba(79,70,229,.35);

}

.swal2-popup{

    border-radius:20px;

}

.swal2-title{

    font-size:30px !important;

    font-weight:700 !important;

}

.swal2-confirm{

    background:#4F46E5 !important;

    border-radius:10px !important;

    padding:10px 28px !important;

}

.swal2-cancel{

    border-radius:10px !important;

    padding:10px 28px !important;

}

        `;

                        document.head.appendChild(style);
                    },

                    preConfirm: () => {

                        const selected = document.querySelector(
                            'input[name="selectedShift"]:checked'
                        );

                        if (!selected) {

                            Swal.showValidationMessage(
                                "Please select a shift"
                            );

                            return false;
                        }

                        return selected.value;
                    }

                });
                if (shiftPopup.isConfirmed) {

                    await handlePunch(
                        1,
                        shiftPopup.value,
                        1
                    );

                    return;
                }
            }
            // =====================================
            // BRANCH CONFIRMATION
            // =====================================

            if (
                res.success ===
                "branch_confirmation"
            ) {

                const result = await Swal.fire({

                    title: "Branch Changed",

                    text: res.message,

                    icon: "warning",

                    showCancelButton: true,

                    confirmButtonText: "Continue",

                    cancelButtonText: "Cancel"
                });

                function formatTime(time) {

                    const [hour, minute] = time.split(":");

                    let h = parseInt(hour);

                    const ampm = h >= 12 ? "PM" : "AM";

                    h = h % 12;

                    if (h === 0) h = 12;

                    return `${h}:${minute} ${ampm}`;
                }
                if (result.isConfirmed) {

                    let html = `<div class="shift-container">`;

                    res.shifts.forEach((shift) => {

                        const shiftColors = {
                            "Day Shift": "#FFDCE5",
                            "Morning Shift": "#DCFCE7",
                            "Evening Shift": "#D6EFFF",
                            "Night Shift": "#E9D8FD",
                            "Afternoon Shift": "#FFF1C2",
                            "Fixed Shift": "#D9F8F0"
                        };

                        const bgColor =
                            shiftColors[shift.type_name.trim()] || "#F5F5F5";
                        html += `
<label class="shift-card" style="background:${bgColor};">

    <input
        type="radio"
        name="selectedShift"
        value="${shift.shifttype_id}"
    >

    <div class="shift-icon">
        🕒
    </div>

    <div class="shift-name">
        ${shift.type_name}
    </div>

    <div class="shift-time">
        ${formatTime(shift.shift_from)}
        -
        ${formatTime(shift.shift_to)}
    </div>

</label>
`;
        //                 html += `
        // <label class="shift-card" style="background:${bgColor}">
        //     <input
        //         type="radio"
        //         name="selectedShift"
        //         value="${shift.shifttype_id}"
        //     />

        //     <div class="shift-content">
        //         <div class="shift-icon">🕒</div>

        //         <div class="shift-details">
        //             <div class="shift-name">
        //                 ${shift.type_name}
        //             </div>

        //             <div class="shift-time">
        //                 ${shift.shift_from} - ${shift.shift_to}
        //             </div>
        //         </div>
        //     </div>
        // </label>
        // `;
                    });

                    html += `</div>`;
                    const shiftPopup = await Swal.fire({

                        title: "Select Shift",

                        html,

                        width: "760px",

                        showCancelButton: true,

                        confirmButtonText: "Continue",

                        cancelButtonText: "Cancel",

                        customClass: {
                            popup: "shift-popup"
                        },

                        didOpen: () => {

                            const style = document.createElement("style");

                            style.innerHTML = `

.shift-container{
    display:grid;
    grid-template-columns:repeat(auto-fit,minmax(180px,1fr));
    gap:14px;
    margin-top:15px;
}

.shift-card{

    position:relative;

    padding:22px;

    border-radius:18px;

    text-align:center;

    cursor:pointer;

    transition:.3s;

    border:2px solid transparent;
}

.shift-card:hover{

    transform:translateY(-5px);

    box-shadow:0 12px 25px rgba(0,0,0,.18);
}

.shift-card input{

    position:absolute;

    right:15px;

    top:15px;

    transform:scale(1.2);
}

.shift-card:has(input:checked){

    border:2px solid #4F46E5;

    box-shadow:0 0 15px rgba(79,70,229,.3);
}

.shift-icon{

    width:65px;

    height:65px;

    margin:auto;

    border-radius:50%;

    background:#fff;

    display:flex;

    justify-content:center;

    align-items:center;

    font-size:30px;

    box-shadow:0 4px 10px rgba(0,0,0,.1);
}

.shift-name{

    margin-top:18px;

    font-size:22px;

    font-weight:700;

    color:#222;
}

.shift-time{

    margin-top:12px;

    display:inline-block;

    padding:8px 18px;

    background:rgba(255,255,255,.65);

    border-radius:25px;

    font-size:15px;

    font-weight:600;

    color:#444;
}

.swal2-popup{

    border-radius:20px;
}

.swal2-title{

    font-size:32px !important;

    font-weight:700 !important;
}

.swal2-confirm{

    background:#4F46E5 !important;

    border-radius:10px !important;
}

.swal2-cancel{

    border-radius:10px !important;
}

`;

                            document.head.appendChild(style);
                        },

                        preConfirm: () => {

                            const selected = document.querySelector(
                                'input[name="selectedShift"]:checked'
                            );

                            if (!selected) {

                                Swal.showValidationMessage(
                                    "Please select a shift"
                                );

                                return false;
                            }

                            return selected.value;
                        }

                    });
                    // const shiftPopup = await Swal.fire({

                    //     title: "Select Shift",

                    //     html,

                    //     width: "720px",

                    //     showCancelButton: true,

                    //     confirmButtonText: "Continue",

                    //     preConfirm: () => {

                    //         const selected = document.querySelector(
                    //             'input[name="selectedShift"]:checked'
                    //         );

                    //         if (!selected) {

                    //             Swal.showValidationMessage(
                    //                 "Please select a shift"
                    //             );

                    //             return false;
                    //         }

                    //         return selected.value;
                    //     }

                    // });

                    if (shiftPopup.isConfirmed) {

                        await handlePunch(
                            1,                     // force_punch
                            shiftPopup.value,      // selected shift
                            1                      // continue_assigned
                        );
                    }
                }
                // if (result.isConfirmed) {

                //     await handlePunch(
                //         1,
                //         selectedShiftId
                //     );
                // }

                return;
            }

            // =====================================
            // SHIFT CONFIRMATION
            // =====================================

            if (
                res.success ===
                "approval_required"
            ) {

                const result = await Swal.fire({

                    title: "Shift Not Assigned",

                    text: res.message,

                    icon: "warning",

                    showCancelButton: true,

                    confirmButtonText: "Continue",

                    cancelButtonText: "Cancel"
                });

                if (result.isConfirmed) {

                    await handlePunch(
                        1,
                        selectedShiftId
                    );
                }

                return;
            }

            // =====================================
            // BRANCH + SHIFT CONFIRMATION
            // =====================================

            if (
                res.success ===
                "branch_and_shift_confirmation"
            ) {

                const result = await Swal.fire({

                    title: "Branch & Shift Mismatch",

                    html: `
                    <p>
                        Selected branch and shift are not assigned to you.
                    </p>
                    <p>
                        Do you want to continue?
                    </p>
                `,

                    icon: "warning",

                    showCancelButton: true,

                    confirmButtonText: "Continue",

                    cancelButtonText: "Cancel"
                });

                if (result.isConfirmed) {

                    await handlePunch(
                        1,
                        selectedShiftId
                    );
                }

                return;
            }

            // =====================================
            // SUCCESS
            // =====================================

            if (res.success === true) {

                toast.success(res.message);

                fetchAttendance(attendanceDate);

                return;
            }

            toast.error(res.message);

        } catch (error) {

            console.log("ERROR :", error);

            toast.error(
                error.response?.data?.message ||
                "Something went wrong"
            );
        }
    };
    // const handlePunch = async () => {

    //     try {

    //         const response = await axios.post(
    //             `${baseurladdress}punchattendance`,
    //             {
    //                 staffid: accessuserid,
    //                 branch_id: branchId,
    //                 date: attendanceDate,
    //                 shift_id: shiftDetails.type_id
    //             },
    //             {
    //                 headers: {
    //                     Authorization: `Bearer ${accesstoken}`
    //                 }
    //             }
    //         );

    //         console.log("Punch Response:", response.data);

    //         if (response.data.success) {

    //             toast.success(response.data.message);

    //             Refresh attendance list
    //             fetchAttendance(attendanceDate);

    //         } else {

    //             toast.error(response.data.message);

    //         }

    //     } catch (error) {

    //         console.log(error);

    //         toast.error("Something went wrong");

    //     }
    // };
    
    const fetchAttendance = async (selectedDate) => {

        try {

            const response = await axios.get(
                `${baseurladdress}attendanceByDate/${accessuserid}/${selectedDate}`,
                {
                    headers: {
                        Authorization: `Bearer ${accesstoken}`
                    }
                }
            );

            if (response.data.status === "success") {
                setStaffList(response.data.response || []);
            }
            console.log(
                            "Attendance List:",
                           response.data.response
                       );
        } catch (error) {
            console.log(error);
        }
    };
    useEffect(() => {

        fetchAttendance(attendanceDate);

    }, []);
    return (
        <div>
            <Topnavbar />
            <Sidennav />
            <ToastContainer />
            <div className="content-wrap">
                <div className="main">
                    <div className="container-fluid">

                        <div className="card shadow-sm border-0 mb-4">

                            <div className="card-header bg-white">
                                <h5 className="mb-1 fw-bold">
                                    Employee Attendance Management
                                </h5>

                                <small className="text-muted">
                                    Track and manage employee attendance records
                                </small>
                            </div>

                            <div className="card-body">

                                <div className="row align-items-end">

                                    <div className="col-lg-4 col-md-6">
                                        <label className="form-label fw-semibold">
                                            Branch
                                        </label>

                                        <Select
                                            options={branch.map((item) => ({
                                                value: item.branch_id,
                                                label: item.branch_name
                                            }))}
                                            value={
                                                branchId
                                                    ? {
                                                        value: branchId,
                                                        label: selectedBranchName
                                                    }
                                                    : null
                                            }
                                            onChange={(selectedOption) => {
                                                setBranchId(
                                                    selectedOption
                                                        ? selectedOption.value
                                                        : ""
                                                );

                                                setSelectedBranchName(
                                                    selectedOption
                                                        ? selectedOption.label
                                                        : ""
                                                );
                                            }}
                                            placeholder="Select Branch"
                                            isSearchable
                                        />
                                    </div>

                                    <div className="col-lg-3 col-md-6">
                                        <label className="form-label fw-semibold">
                                            Attendance Date
                                        </label>

                                        <input
                                            type="date"
                                            className="form-control"
                                            value={attendanceDate}
                                            // onChange={(e) =>
                                            //     setAttendanceDate(e.target.value)
                                            // }
                                            onChange={(e) => {

                                                const selectedDate = e.target.value;

                                                setAttendanceDate(selectedDate);

                                                fetchAttendance(selectedDate);

                                            }}
                                        />
                                    </div>

                                    <div className="col-lg-2 col-md-3">
                                     
                                        <button
                                            className="btn btn-success w-100"
                                            onClick={() => handlePunch()}
                                            style={{
                                                height: "38px",
                                                fontWeight: "600"
                                            }}
                                        >
                                            Punch
                                        </button>
                                      
                                        {/* <button
                                            className="btn btn-success w-100"
                                            onClick={handlePunch}
                                            style={{
                                                height: "38px",
                                                fontWeight: "600"
                                            }}
                                        >
                                            <i className="fa fa-hand-pointer-o me-2"></i>
                                            Punch
                                        </button>*/}
                                    </div>

                                </div>

                            </div>

                        </div>
                        <div className="card shadow-sm border-0">

                            <div
                                className="card-header bg-white d-flex justify-content-between align-items-center"
                            >
                                <div>
                                    <h5 className="mb-0 fw-bold">
                                        Attendance List
                                    </h5>

                                    <small className="text-muted">
                                        Daily attendance details
                                    </small>
                                </div>
                            </div>

                            <div className="card-body p-0">

                                <div className="table-responsive">

                                    <table className="table table-hover align-middle mb-0">

                                        <thead
                                            style={{
                                                backgroundColor: "#f8fafc"
                                            }}
                                        >
                                            <tr>

                                                <th className="text-center">
                                                    Sl.No
                                                </th>

                                                <th>
                                                    Staff Name
                                                </th>

                                                <th>
                                                    Shift Name
                                                </th>

                                                <th>
                                                    Branch Name
                                                </th>

                                                <th>
                                                    Date
                                                </th>

                                                <th>
                                                    Punch In
                                                </th>

                                                <th>
                                                    Punch Out
                                                </th>

                                            </tr>
                                        </thead>

                                        <tbody>
                                            {staffList.length > 0 ? (
                                                staffList.map((item, index) => (
                                                    <tr key={item.attendance_id}>
                                                        <td className="text-center">
                                                            {index + 1}
                                                        </td>

                                                        <td>
                                                            {item.attendance_empname}
                                                        </td>

                                                        <td>
                                                            {item.attendance_shiftname}
                                                        </td>

                                                        <td>
                                                            {item.attendance_branchname}
                                                        
</td>
                                                        <td>
                                                           
                                                                {item.attendance_date}
                                                            
                                                        </td>

                                                        <td>
                                                            <span
                                                                style={{
                                                                    color: "green",
                                                                    fontWeight: "600"
                                                                }}
                                                            >
                                                                {item.attendance_punching
                                                                    ? new Date(item.attendance_punching)
                                                                        .toLocaleTimeString("en-IN")
                                                                    : "-"}
                                                            </span>
                                                        </td>

                                                        <td>
                                                            <span
                                                                style={{
                                                                    color: "red",
                                                                    fontWeight: "600"
                                                                }}
                                                            >
                                                                {item.attendance_punchout
                                                                    ? new Date(item.attendance_punchout)
                                                                        .toLocaleTimeString("en-IN")
                                                                    : "-"}
                                                            </span>
                                                        </td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td colSpan="7" className="text-center py-5">
                                                        No attendance records found
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>

                                    </table>

                                </div>

                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Attendancemanagement;